const SafeDealTheme = {
  desktopModal: {
    width: '400px',
    headerPadding: '20px',
    fontWeight: '600',
  },
  safeDealInfoModal: {
    gap: '8px',
  },
};

export default SafeDealTheme;
